import type { LookoRouteObject } from '@/router/LookoRouteObject';

export const 공지사항_페이지_라우터 = {
  ['dashboard-notice-setting']: {
    path: '/manager/dashboard-notice-setting',
    async lazy() {
      const { default: Page } = await import('@/router/manager/notice-setting/NoticeSettingPage');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '대시보드 공지',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
  ['popup-notice-setting']: {
    path: '/manager/popup-notice-setting',
    async lazy() {
      const { default: Page } = await import('@/router/manager/notice-setting/PopupNoticeSetting');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '팝업 공지',
      displayInSidebarMenu: true,
    },
  } satisfies LookoRouteObject,
};

export const 공지사항_라우트_리스트: LookoRouteObject[] = Object.values(공지사항_페이지_라우터);
